
function lazy(name) {
    return () => import('@/views/' + name)
}
export default [
    {
        path: '/news/index',
        name: 'news-index',
        component: lazy('news/index.vue')
    },
    {
        path: '/news/newsdetail',
        name: 'news-newsdetail',
        component: lazy('news/newsdetail.vue')
    }
]


// WEBPACK FOOTER //
// ./src/router/news.js